var _Grid, _Switch, _Grid2, _Grid3, _Divider;
import React from 'react';
import { get, noop } from 'lodash';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, Button, Divider, FormControlLabel, Grid2, Stack, Switch, SwitchSVGContentCheck, SwitchSVGContentNotification, TextField, TextFieldSearch, Typography } from '@lumahealthhq/ui-core';
import { useCurrentUser } from '@lumahealthhq/ui-model';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackFormFieldsPatient() {
  var intl = useIntl();
  var currentUser = useCurrentUser();
  var linkToEhrOption = get(currentUser, 'settings.patients.linkToEhrOption.enabled', false);
  return /*#__PURE__*/_jsx("form", {
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: 4,
      children: [/*#__PURE__*/_jsx(Stack, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          children: intl.formatMessage({
            id: "+0hh6g",
            defaultMessage: [{
              "type": 0,
              "value": "Patient"
            }]
          })
        })
      }), _Grid || (_Grid = /*#__PURE__*/_jsx(Grid2, {
        container: true,
        columnSpacing: 2,
        children: /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          xl: 7,
          children: /*#__PURE__*/_jsx(TextFieldSearch, {
            fullWidth: true,
            onChange: noop,
            disabled: true
          })
        })
      })), /*#__PURE__*/_jsxs(Grid2, {
        container: true,
        columnSpacing: 2,
        rowSpacing: 4,
        children: [/*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            required: true,
            label: intl.formatMessage({
              id: "pONqz8",
              defaultMessage: [{
                "type": 0,
                "value": "First name"
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            required: true,
            label: intl.formatMessage({
              id: "txUL0F",
              defaultMessage: [{
                "type": 0,
                "value": "Last name"
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            required: true,
            label: intl.formatMessage({
              id: "GFTdXw",
              defaultMessage: [{
                "type": 0,
                "value": "Date of birth"
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            label: intl.formatMessage({
              id: "awItTC",
              defaultMessage: [{
                "type": 0,
                "value": "Contact language"
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            label: intl.formatMessage({
              id: "V5DGmb",
              defaultMessage: [{
                "type": 0,
                "value": "Street Address"
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          lg: 6,
          children: /*#__PURE__*/_jsx(TextField, {
            label: intl.formatMessage({
              id: "oVGrht",
              defaultMessage: [{
                "type": 0,
                "value": "Apartment,suite,floor,etc."
              }]
            }),
            disabled: true,
            fullWidth: true
          })
        }), linkToEhrOption && /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Grid2, {
            container: true,
            spacing: 2,
            children: /*#__PURE__*/_jsx(Grid2, {
              xs: 12,
              md: 4,
              lg: 3,
              children: /*#__PURE__*/_jsx(Box, {
                children: /*#__PURE__*/_jsxs(Stack, {
                  spacing: 1,
                  children: [/*#__PURE__*/_jsx(Box, {
                    sx: {
                      '& > span:nth-of-type(2)': {
                        top: 0,
                        display: 'flex',
                        right: '-12',
                        position: 'absolute'
                      }
                    },
                    children: /*#__PURE__*/_jsx(Typography, {
                      variant: "caption",
                      color: "inherit",
                      children: intl.formatMessage({
                        id: "G2f0BQ",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Link patient to EHR"
                        }]
                      })
                    })
                  }), /*#__PURE__*/_jsx(FormControlLabel, {
                    disabled: true,
                    sx: function sx(theme) {
                      return {
                        width: 'fit-content',
                        minHeight: theme.spacing(7)
                      };
                    },
                    control: _Switch || (_Switch = /*#__PURE__*/_jsx(Switch, {
                      disabled: true,
                      checked: false,
                      svgContentChecked: SwitchSVGContentCheck
                    })),
                    label: intl.formatMessage({
                      id: "3a5wL8",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Active"
                      }]
                    })
                  })]
                })
              })
            })
          })
        }), _Grid2 || (_Grid2 = /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Divider, {})
        })), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "h5",
            children: intl.formatMessage({
              id: "RYiGdc",
              defaultMessage: [{
                "type": 0,
                "value": "Contact Information"
              }]
            })
          })
        }), /*#__PURE__*/_jsx(Grid2, {
          xs: 12,
          children: /*#__PURE__*/_jsxs(Grid2, {
            container: true,
            columnGap: 1,
            rowGap: 5,
            children: [_Grid3 || (_Grid3 = /*#__PURE__*/_jsx(Grid2, {
              xs: "auto",
              children: /*#__PURE__*/_jsx(Switch, {
                checked: true,
                disabled: true,
                color: "error",
                svgContentChecked: SwitchSVGContentNotification
              })
            })), /*#__PURE__*/_jsxs(Grid2, {
              xs: true,
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "body1",
                children: intl.formatMessage({
                  id: "2Iog9o",
                  defaultMessage: [{
                    "type": 0,
                    "value": "Do not contact"
                  }]
                })
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "caption",
                color: "text.secondary",
                children: intl.formatMessage({
                  id: "JpvWKQ",
                  defaultMessage: [{
                    "type": 0,
                    "value": "When enabled, the patient has opted out of receiving messages from Luma Health."
                  }]
                })
              })]
            })]
          })
        })]
      }), _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 2,
        justifyContent: "flex-end",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: true,
          variant: "text",
          children: intl.formatMessage({
            id: "47FYwb",
            defaultMessage: [{
              "type": 0,
              "value": "Cancel"
            }]
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: true,
          type: "submit",
          variant: "primary",
          children: intl.formatMessage({
            id: "BwPWb5",
            defaultMessage: [{
              "type": 0,
              "value": "Add Patient"
            }]
          })
        })]
      })]
    })
  });
}